module.exports = __webpack_public_path__ + "06_medium_gold.5742f218.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/06_medium_gold.png
// module id = BV/V
// module chunks = 0